import React from 'react';
import { BitrixBotManager } from '@/components/channels/BitrixBotManager';

interface AutomationBitrixBotProps {
  channelId: number;
  openChannelsBX: Array<{ isActive: boolean }>;
  bitrixChatBot?: unknown;
  onStatusChange?: () => void;
}

export const AutomationBitrixBot: React.FC<AutomationBitrixBotProps> = ({ channelId, openChannelsBX, bitrixChatBot, onStatusChange }) => {
  console.log('[AutomationBitrixBot] MOUNT', { channelId, openChannelsBX, bitrixChatBot });
  const activeOpenChannel = Array.isArray(openChannelsBX) ? openChannelsBX.find(oc => oc.isActive) : null;
  console.log('[AutomationBitrixBot] activeOpenChannel', activeOpenChannel);
  if (!activeOpenChannel) return null; 
  return (
    <div className="mb-4">
      <BitrixBotManager
        channelId={channelId}
        isActive={activeOpenChannel.isActive}
        botInstalled={!!bitrixChatBot}
        onStatusChange={onStatusChange}
      />
    </div>
  );
};
